import i18n from 'i18next';

export default () => ([
  {
    label: i18n.t('sunday-abbreviation'),
    value: 'su',
  },
  {
    label: i18n.t('monday-abbreviation'),
    value: 'mo',
  },
  {
    label: i18n.t('tuesday-abbreviation'),
    value: 'tu',
  },
  {
    label: i18n.t('wednesday-abbreviation'),
    value: 'we',
  },
  {
    label: i18n.t('thursday-abbreviation'),
    value: 'th',
  },
  {
    label: i18n.t('friday-abbreviation'),
    value: 'fr',
  },
  {
    label: i18n.t('saturday-abbreviation'),
    value: 'sa',
  },
]);
